<template>
    <div class="brw">
        <p>{{ $ml.get('pixOFOrderReviewRedirectWarning1') }}<strong v-text="selectedBank.organizationName" />{{ $ml.get('pixOFOrderReviewRedirectWarning2') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            selectedBank: {
                type: Object,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .brw {
        background-color: #EFF1F3;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;

        p,
        strong {
            font-size: 16px;
            color: #000000;
            margin: 0;
        }
    }
</style>
